export const column: { id: number; label: string }[] = [
  { id: 0, label: "ID" },
  { id: 1, label: "Наименование" },
  { id: 2, label: 'Дней "от"' },
  { id: 3, label: 'Дней "до"' },
  { id: 4, label: "Цена (без скидки)" },
  { id: 5, label: "Цена (со скидкой)" },
  { id: 6, label: "Действия" },
];
